"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericClusterLegend = exports.GenericFingerprint = exports.GenericLegend = void 0;
const RubikDetail_1 = require("./RubikDetail/RubikDetail");
const NeuralDetail_1 = require("./NeuralDetail/NeuralDetail");
const ChessDetail_1 = require("./ChessDetail/ChessDetail");
const CoralDetail_1 = require("./CoralDetail/CoralDetail");
const StoryDetail_1 = require("./StoryDetail/StoryDetail");
const GoDetail_1 = require("./GoDetail/GoDetail");
const Typography_1 = require("@material-ui/core/Typography");
const Table_1 = require("@material-ui/core/Table");
const TableBody_1 = require("@material-ui/core/TableBody");
const TableRow_1 = require("@material-ui/core/TableRow");
const TableCell_1 = require("@material-ui/core/TableCell");
const TableContainer_1 = require("@material-ui/core/TableContainer");
const React = require("react");
const RubikFingerprint_1 = require("./RubikFingerprint/RubikFingerprint");
const ChessFingerprint_1 = require("./ChessFingerprint/ChessFingerprint");
const datasetselector_1 = require("../util/datasetselector");
exports.GenericLegend = ({ type, vectors, aggregate }) => {
    switch (type) {
        case datasetselector_1.DatasetType.Story:
            return React.createElement(StoryDetail_1.StoryLegend, { selection: vectors });
        case datasetselector_1.DatasetType.Rubik:
            return React.createElement(RubikDetail_1.RubikLegend, { selection: vectors });
        case datasetselector_1.DatasetType.Neural:
            return React.createElement(NeuralDetail_1.NeuralLegend, { selection: vectors, aggregate: aggregate });
        case datasetselector_1.DatasetType.Chess:
            return React.createElement(ChessDetail_1.ChessLegend, { selection: vectors });
        case datasetselector_1.DatasetType.Coral:
            return React.createElement(CoralDetail_1.CoralLegend, { selection: vectors, aggregate: aggregate });
        case datasetselector_1.DatasetType.Go:
            return React.createElement(GoDetail_1.GoLegend, { selection: vectors, aggregate: aggregate });
        default:
            return React.createElement(CoralDetail_1.CoralLegend, { selection: vectors, aggregate: aggregate });
    }
};
exports.GenericFingerprint = ({ type, vectors, scale }) => {
    switch (type) {
        case datasetselector_1.DatasetType.Rubik:
            return React.createElement(RubikFingerprint_1.RubikFingerprint, { width: 81 * scale, height: 108 * scale, vectors: vectors });
        case datasetselector_1.DatasetType.Chess:
            return React.createElement(ChessFingerprint_1.ChessFingerprint, { width: 80 * scale, height: 80 * scale, vectors: vectors });
        case datasetselector_1.DatasetType.Coral:
            return React.createElement(CoralDetail_1.CoralLegend, { selection: vectors, aggregate: true });
        default:
            return React.createElement("div", null);
    }
};
function GenericClusterLegend({ cluster, type }) {
    return React.createElement("div", null,
        React.createElement(Typography_1.default, { variant: 'subtitle2' }, "Cluster Information"),
        React.createElement(TableContainer_1.default, null,
            React.createElement(Table_1.default, { size: "small", "aria-label": "simple table" },
                React.createElement(TableBody_1.default, null,
                    React.createElement(TableRow_1.default, null,
                        React.createElement(TableCell_1.default, null, "Probability"),
                        React.createElement(TableCell_1.default, { align: "right" }, cluster.getProbability().toFixed(2))),
                    React.createElement(TableRow_1.default, null,
                        React.createElement(TableCell_1.default, null, "STD"),
                        React.createElement(TableCell_1.default, { align: "right" }, cluster.getSTD().toFixed(2))),
                    React.createElement(TableRow_1.default, null,
                        React.createElement(TableCell_1.default, null, "Score"),
                        React.createElement(TableCell_1.default, { align: "right" }, cluster.meanScore().toFixed(2))),
                    React.createElement(TableRow_1.default, null,
                        React.createElement(TableCell_1.default, null, "Count"),
                        React.createElement(TableCell_1.default, { align: "right" }, cluster.vectors.length.toFixed(2))),
                    React.createElement(TableRow_1.default, null,
                        React.createElement(TableCell_1.default, null, "Unique Lines"),
                        React.createElement(TableCell_1.default, { align: "right" }, cluster.differentLines().toFixed(2))),
                    React.createElement(TableRow_1.default, null,
                        React.createElement(TableCell_1.default, null, "Ordering"),
                        React.createElement(TableCell_1.default, { align: "right" }, cluster.order().toFixed(2)))))),
        React.createElement("div", { className: "speech-bubble-ds-arrow" }));
}
exports.GenericClusterLegend = GenericClusterLegend;
